<header class="page-header">
  <div class="page-header__row">
    <h1>Build report package</h1>
    <span class="badge">Beta</span>
  </div>
  <p class="lede">
    Deliver report data in a structured Excel file and convert it to an xBRL-CSV report
    package (.zip). One report set (framework) per file.
  </p>
</header>

<section class="steps">
  <h2>How it works</h2>
  <ol>
    <li>
      <strong>Download</strong> the Excel template below. It contains the required column
      headers plus a few sample rows (shown in grey italics).
    </li>
    <li>
      <strong>Fill</strong> the sheet with your own report data — replace the sample rows,
      one row per cell value. Keep the header row unchanged. The columns are a subset of
      the Reports export preview, so you can copy values from an exported workbook.
      Units, decimals and datapoint mapping are derived automatically from the table and
      cell coordinates. For open-row tables (e.g. C_27–C_29) use a sequential
      <em>Rownr</em> (0001, 0002, …) and put the counterparty identifier in column 010/011.
    </li>
    <li>
      <strong>Upload</strong> the filled template with the file picker below to generate
      the report package.
    </li>
  </ol>
  <a class="btn btn--primary" href="/templates/report-data-template.xlsx" download>
    Download Excel template
  </a>
</section>

<app-file-upload-zone
  label="Filled Excel template"
  hint="One .xlsx file, filled from the downloaded template."
  accept=".xlsx,.XLSX"
  [multiple]="false"
  (filesSelected)="onFile($event)"
/>

@if (filename()) {
  <p class="meta">File: <strong>{{ filename() }}</strong></p>
  <p class="notice">
    Template received. Generating the xBRL-CSV report package (.zip) from this file is
    not available yet — it is the next step on the roadmap. Your file is not stored;
    re-upload it once generation is live.
  </p>
}
